<template>
  <div v-if="optionsReady && showNewsletterButton" class="newsletter-button" tabindex="0">
    <div class="newsletter-modal-wrapper">
      <div class="newsletter-button-container">
        <a @click="openModal()" v-text="openButtonText"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["blockdata"],
  name: "newsletter-button",
  data() {
    return {
      options: null,
      optionsReady: false,
      showNewsletterButton: false,
      openButtonText: null
    };
  },
  mounted(){
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/acf/v3/options/options",
        function(response) {
          self.options = response.acf;
          self.optionsReady = true;
          self.showNewsletterButton = self.options.show_newsletter_modal;
          self.openButtonText = self.capitalizeFirstLetter(self.options.newsletter_modal_title);
        }
      )
        .done(function() {})
        .fail(function() {});
    },
    capitalizeFirstLetter: function(strN) {
      return strN.charAt(0).toUpperCase() + strN.slice(1).toLowerCase();
    },
    openModal: function() {
      this.$root.$emit('forceOpenModal');
    }
  }
}
</script>



// WEBPACK FOOTER //
// NewsletterButton.vue?73d8de20